<template>
    <div class="community__item-container">
        <div class="community__item-outer">
            <div :class="'community__item ' + cls">
                <div class="community__item-inner--decoration"
                     :style="`background-image: url('${require('@/assets/img/pro-community-background.svg')}')`">
                </div>
                <div class="community__item-inner">
                    <h2 class="item__caption">
                        {{community.key.name}}</h2>
                    <p class="item__subtitle">
                      <span v-if="type === 'closed'">
                        {{usersCount}} users
                      </span>
                    </p>
                    <div class="community__label">
                        pro
                    </div>
                </div>
            </div>
        </div>
        <div class="community-item__info">
            <div class="community-item__info-item">
                <div class="info-row">
                    <v-img :src="require('@/assets/img/icons/folder-icon.svg')"></v-img>
                    {{nProjectsUsing}}
                </div>
                <div class="info-row">
                    <v-img :src="require('@/assets/img/icons/clock.svg')"></v-img>
                    {{created_timestamp}}
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import moment from "moment";
    import {store} from "../../store/store";

    export default {
        name: "ProCommunityItem",
        props: ['community', 'errMessage', 'locked', 'dateRange'],
        computed: {
            created_timestamp() {
                return moment(this.community.created_at).fromNow()
            },
            cls () {
                return this.locked ? "locked-pro-community" : "pro-community"
            },
            usersCount() {
                return this.community.usersCount
            },
            nProjectsUsing() {
              return this.community.nProjectsUsing
            },
            type() {
                return this.community.type
            }
},
        mounted() {
            if (!this.community.type) {
                store.dispatch('communityKPIs', {key: this.community.key, dateRange: this.dateRange})
            }
        }
    }
</script>

<style scoped>

</style>
